export default __webpack_public_path__ + "static/media/detail_mobile_4_5.fd6da0e7.png";